import { render, staticRenderFns } from "./XeroDocumentation.vue?vue&type=template&id=3f2ccd8b&scoped=true&"
import script from "./XeroDocumentation.vue?vue&type=script&lang=js&"
export * from "./XeroDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./XeroDocumentation.vue?vue&type=style&index=0&id=3f2ccd8b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2ccd8b",
  null
  
)

export default component.exports